import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { DICT, LangContext, useLang } from "./i18n";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { HowItWorks } from "./components/HowItWorks";
import { PainSection } from "./components/PainSection";
import { BentoGrid } from "./components/BentoGrid";
import { Pricing } from "./components/Pricing";
import { AiDemo } from "./components/AiDemo";
import { WebAppBanner } from "./components/WebAppBanner";
import { WhyUs } from "./components/WhyUs";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import Privacy from "./components/Privacy";

const SALON_IMG =
  "https://images.unsplash.com/photo-1605497788044-5a32c7078486?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxoYWlyJTIwc2Fsb24lMjBoYWlyY3V0fGVufDB8fHx8MTc5MTI4OTEwOXww&ixlib=rb-4.1.0&q=85";
const RESTAURANT_IMG =
  "https://images.unsplash.com/photo-1600891964599-f61ba0e24092?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwZGluaW5nJTIwZm9vZHxlbnwwfHx8fDE3OTEyODkxMDl8MA&ixlib=rb-4.1.0&q=85";

function Landing() {
  const { t } = useLang();
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <HowItWorks />
        <PainSection
          id="hair-salons"
          testId="salon-section"
          data={t.salon}
          image={SALON_IMG}
          imageAlt="Parrucchiere al lavoro nel salone"
        />
        <PainSection
          id="restaurants"
          testId="restaurant-section"
          data={t.restaurant}
          image={RESTAURANT_IMG}
          imageAlt="Ristorante in ora di punta"
          reverse
        />
        <BentoGrid />
        <Pricing />
        <AiDemo />
        <WebAppBanner />
        <WhyUs />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

function App() {
  const [lang, setLang] = useState("it");
  const t = DICT[lang];

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </LangContext.Provider>
  );
}

export default App;
